import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { List as MuiList, useTheme } from '@mui/material';

import { SIcon, SListItem, SNavLink } from './styled';

import { selectors as chatSelectors } from '../../services/chat/index';
import { selectors as userSelectors } from 'services/user';

import getPermission from 'lib/utils/getPermission';
import config from 'config';

export default function Links({ list }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const theme = useTheme()
  const handleLinkClick = (onClickAction, dispatch) => {
    if (onClickAction) {
      onClickAction(dispatch);
    }
    window.scrollTo(0, 0);
  };
  const unreadMessageCount = useSelector(chatSelectors.getUnreadMessageCount);
  const triggeredAlertsCount = useSelector(
    userSelectors.getTriggeredAlertsCount
  );

  return (
    <MuiList>
      {list.map(({ text, icon, link, onClick }, index) => {
        if (
          text === 'Schedule' &&
          !getPermission('APPOINTMENT', 'read') &&
          !getPermission('TEAM_APPOINTMENT', 'read')
        )
          return null;
        if (
          text === 'Team management' &&
          !getPermission('MEMBERS', 'read') &&
          !getPermission('ADMINISTRATOR_MEMBERS', 'read') &&
          !getPermission('CARE_TEAM', 'read') &&
          !getPermission('SUB_ORGANIZATION', 'read') &&
          !getPermission('ROLES_AND_RIGHTS', 'read')
        )
          return null;
        if (
          text === 'Chat' &&
          !getPermission('CHAT_WITH_PATIENTS', 'read') &&
          !getPermission('CHAT_BETWEEN_CARE_TEAM_MEMBERS', 'read')
        )
          return null;

        if (
          text === 'Organization' &&
          !getPermission('MASTER_ORGANIZATION', 'read')
        )
          return null;
        if (
          text === 'Care plans' &&
          !getPermission('CARE_PATHWAY_BUILDER_CARE_PATHWAY', 'read') &&
          !getPermission('PUBLISHED_CARE_PATHWAY_BUILDER_CARE_PATHWAY', 'read') &&
          !getPermission('RETIRED_CARE_PATHWAY_BUILDER_CARE_PATHWAY', 'read') &&
          !(getPermission('CARE_PROGRAMS', 'read') && config.CARE_PROGRAMS_ENABLED)
        )
          return null;
        if (text === 'Patients' && !getPermission('TRIAGE_DASHBOARD', 'read'))
          return null;
        if (
          text === 'Alerts' &&
          !getPermission('GLOBAL_ALERT_MANAGEMENT', 'read') &&
          !getPermission('ASSIGNED_ALERT', 'read')
        )
          return null;
        if (
          text === 'Templates' &&
          !getPermission('QUESTIONNAIRES', 'read') &&
          !getPermission('METRIC_DEFINITIONS', 'read') &&
          !getPermission('CHARTS_MANAGEMENT', 'read')
        )
          return null;
        return (
          <div key={index} style={{ position: 'relative' }}>
            <SNavLink
              key={t(text)}
              exact
              to={link}
              activeClassName={'selectedItem'}
              onClick={() => handleLinkClick(onClick, dispatch)}
              data-testid={`nav-link-${text.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <SListItem disableGutters={true}>
                <SIcon>{icon}</SIcon>
              </SListItem>
            </SNavLink>
            {((text === 'Chat' && unreadMessageCount > 0) ||
              (text === 'Alerts' && triggeredAlertsCount > 0)) && (
                <div
                  style={{
                    height: 22,
                    width: 22,
                    backgroundColor: theme.palette.colors.red100,
                    color: theme.palette.colors.white,
                    borderRadius: '50%',
                    fontSize: 12,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'absolute',
                    top: '-4px',
                    right: 10,
                  }}
                >
                  {(text === 'Chat' && unreadMessageCount) ||
                    (text === 'Alerts' && '!')}
                </div>
              )}
          </div>
        );
      })}
    </MuiList>
  );
}
